import React from 'react'
// components
import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/view'
// context
import { ObjectsAPIContext } from 'containers/ObjectsAndProperties/Edit/layers/API'
// themes
import { colors } from 'themes'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
// view components
import ObjectSecurityForm from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Security/Form'
// utils
import { getOptionFromData } from 'utils/form'

const ObjectSecurity: React.FC = () => {
  // state
  const [isOpen, setIsOpen] = React.useState<boolean>(false)

  const { object } = React.useContext(ObjectsAPIContext)

  // methods
  const expandPanel = (_, expanded) => setIsOpen(expanded)

  // constants
  const initialValues = {
    memberObjectSecurity: getOptionFromData(object.memberObjectSecurity),
    ownerObjectSecurity: getOptionFromData(object.ownerObjectSecurity)
  } as any

  return (
    <Accordion expanded={isOpen} onChange={expandPanel}>
      <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>Security</AccordionSummary>
      <AccordionDetails>
        <ObjectSecurityForm initialValues={initialValues} />
      </AccordionDetails>
    </Accordion>
  )
}

export default ObjectSecurity
